import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

import { IonicModule } from '@ionic/angular';

import { ManualRoleManagementPageRoutingModule } from './manual-role-management-routing.module';

import { ManualRoleManagementPage } from './manual-role-management.page';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    ManualRoleManagementPageRoutingModule
  ],
  declarations: [ManualRoleManagementPage],
  exports: [ManualRoleManagementPage]
})
export class ManualRoleManagementPageModule {}
